"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedHistoryRewardsList = void 0;
var _ = __importStar(require("lodash"));
var TimeUtil_1 = require("../../utils/TimeUtil");
var GroupedHistoryRewardsList = /** @class */ (function (_super) {
    __extends(GroupedHistoryRewardsList, _super);
    function GroupedHistoryRewardsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createGroupedList = function (rewards) {
            var groupedRewards = new GroupedHistoryRewardsList();
            _.forEach(_.mapValues(_.groupBy(rewards, 'reward_id')), function (rewardGroup) {
                var drawDate = rewardGroup[0].extra_data && rewardGroup[0].extra_data.draw_date;
                var referenceDate;
                var displayDate;
                if (!drawDate) {
                    // if draw_date is not available get date of latest activity in group
                    var latestActivity = _.maxBy(rewardGroup, 'date_created');
                    !!latestActivity && /^-{0,1}\d+$/.test(latestActivity.date_created)
                        ? (referenceDate = !!latestActivity ? parseInt(latestActivity.date_created, 10) : 0)
                        : (referenceDate = !!latestActivity ? TimeUtil_1.formatTimeStampToUnixMonthOrdinalDayYear(latestActivity.date_created) : 0);
                    displayDate = TimeUtil_1.formatUnixMonthOrdinalDayYear(referenceDate);
                }
                else {
                    referenceDate = Math.round(TimeUtil_1.parseLocalISOString(drawDate).getTime() / 1000);
                    displayDate = TimeUtil_1.formatLocalUnixMonthOrdinalDayYear(referenceDate);
                }
                rewardGroup.forEach(function (x) {
                    x.dateCreated = TimeUtil_1.formatUnixLongMonthDayCommaYearHourTime(/^-{0,1}\d+$/.test(x.date_created) ? parseInt(x.date_created, 10) : TimeUtil_1.formatTimeStampToUnixMonthOrdinalDayYear(x.date_created));
                });
                groupedRewards.push({ referenceDate: referenceDate, displayDate: displayDate, rewards: rewardGroup });
            });
            // @ts-ignore
            return _.orderBy(groupedRewards, 'referenceDate', 'desc');
        };
        return _this;
    }
    return GroupedHistoryRewardsList;
}(Array));
exports.GroupedHistoryRewardsList = GroupedHistoryRewardsList;
//# sourceMappingURL=GroupedHistoryRewardsList.js.map